import chatbotRequest from '@/service/channel/http'
import type { CloseRoomReq, CloseRoomRes } from '../type/closeRoom'

export function closeRoomApi(data: CloseRoomReq): Promise<CloseRoomRes> {
    return chatbotRequest<CloseRoomRes, CloseRoomReq, CloseRoomRes>({
        url: '/api/room/close',
        method: 'post',
        data,
    })
}